import React, { useState } from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  getStraightPath,
} from '@xyflow/react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { setSidebarOpen, setSidebarData, setSidebarType } from '../../../redux/slices/connectorSlice';
import "../canvas.css"

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  label,
  source,
  target
}) {
  const [isHovered, setIsHovered] = useState(false);
  const dispatch = useDispatch();
  
  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  // Figma-style edge styling with hover effects
  const figmaStyle = {
    stroke: isHovered ? '#06b6d4' : '#22d3ee', // Darker on hover
    strokeWidth: isHovered ? 3 : 2,
    filter: 'drop-shadow(0 1px 2px rgba(34, 211, 238, 0.1))',
    cursor: 'pointer',
    ...style
  };

  const handleAddNodeInMiddle = (e) => {
    e.stopPropagation();
    e.preventDefault();
    
    // Open sidebar with edge insertion context
    dispatch(setSidebarOpen(true));
    dispatch(setSidebarData({ 
      edgeId: id,
      sourceNodeId: source,
      targetNodeId: target,
      insertPosition: { x: labelX, y: labelY },
      label: label // Include label for conditional edges
    }));
    dispatch(setSidebarType('insertNode'));
  };

  return (
    <>
      {/* Invisible wider path for hover detection */}
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth="36"
        strokeLinecap="round"
        pointerEvents="stroke"
        style={{ cursor: 'pointer' }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseMove={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />
      
      {/* Visible edge */}
      <BaseEdge 
        path={edgePath} 
        markerEnd={markerEnd} 
        style={{ ...figmaStyle, pointerEvents: 'none' }} 
        type={label === "If Yes" ? "straight" : "smoothstep"}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            pointerEvents: 'all',
            background: "#fff"
          }}
          className="nodrag nopan"
        >
          {/* Existing label button */}
          {label && (
            <button className="edge-button">
              {label}
            </button>
          )}
          
          {/* Plus button that appears on hover (only if no label or positioned differently) */}
          {isHovered && !label && (
            <Button
              type="primary"
              shape="circle"
              size="small"
              icon={<PlusOutlined />}
              onClick={handleAddNodeInMiddle}
              style={{
                backgroundColor: '#22d3ee',
                borderColor: '#22d3ee',
                color: '#ffffff',
                boxShadow: '0 4px 12px rgba(34, 211, 238, 0.4)',
                width: '32px',
                height: '32px',
                marginTop: label ? '8px' : '0',
                animation: 'fadeIn 0.2s ease-in-out',
                border: '2px solid white'
              }}
              className="edge-hover-button is-visible"
            />
          )}
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
